import Client from './client';

export default class ShopifyMarketsShopSummaries extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getSummaryByShopifyShopId(shopifyShopId, options = {}) {
    return this.makeRequest(`${this.host}/internal/shopify/markets/shopify/shops/${shopifyShopId}/summary`, options);
  }

}
